module.exports = __webpack_public_path__ + "static/img/dog2.bc763e07.png";